import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  ImportedPinCodesModel,
  ManuallyAddedCodesModel,
} from '../../models/codes';

interface ICodesService {
  getGeneratedDefaultCodes: (
    codesNumber: number,
    codeLength: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<string[]>>;
  downloadDefaultCodesTemplate: (
    filename: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadPinCodesTemplate: (
    filename: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  importDefaultCodes: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ManuallyAddedCodesModel>>;
  importPinCodes: (
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ImportedPinCodesModel>>;
  validateDefaultCodes: (
    codes: string[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ManuallyAddedCodesModel>>;
  downloadExistingCodes: (
    productId: number,
    filename: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
}

export const codesService: ICodesService = {
  getGeneratedDefaultCodes(codesNumber, codeLength, axiosConfig) {
    return ajax.get<string[]>(
      `${config.merchantsApiUrl}/codes/generated/default?codesNumber=${codesNumber}&codeLength=${codeLength}`,
      axiosConfig,
    );
  },
  downloadDefaultCodesTemplate(filename, axiosConfig) {
    return ajax.downloadFile(
      `${config.merchantsApiUrl}/codes/templates/default`,
      filename,
      'xlsx',
      axiosConfig,
    );
  },
  downloadPinCodesTemplate(filename, axiosConfig) {
    return ajax.downloadFile(
      `${config.merchantsApiUrl}/codes/templates/pin`,
      filename,
      'xlsx',
      axiosConfig,
    );
  },
  importDefaultCodes(data, axiosConfig) {
    return ajax.post<ManuallyAddedCodesModel>(
      `${config.merchantsApiUrl}/codes/import/default`,
      data,
      axiosConfig,
    );
  },
  importPinCodes(data, axiosConfig) {
    return ajax.post<ImportedPinCodesModel>(
      `${config.merchantsApiUrl}/codes/import/pin`,
      data,
      axiosConfig,
    );
  },
  validateDefaultCodes(codes, axiosConfig) {
    return ajax.post<ManuallyAddedCodesModel>(
      `${config.merchantsApiUrl}/codes/validate/default`,
      { codes },
      axiosConfig,
    );
  },
  downloadExistingCodes(productId, filename, axiosConfig) {
    return ajax.downloadFile(
      `${config.merchantsApiUrl}/codes/${productId}`,
      filename,
      'xlsx',
      axiosConfig,
    );
  },
};
